import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

// Shared FOUNDATION assets, served at /assets/. Each loader falls back to the
// procedural stand-in if the baked asset is missing, so the build never breaks on
// an empty assets folder (ISSUES.md #1/#2 — the procedural generators remain the
// fallback tier, the baked shared assets are the real thing).
export function loadTexture(url: string, fallback: () => THREE.Texture): THREE.Texture {
  const loader = new THREE.TextureLoader()
  const holder = loader.load(url, undefined, undefined, () => {
    const fb = fallback()
    holder.image = fb.image as typeof holder.image
    holder.needsUpdate = true
  })
  holder.anisotropy = 4
  return holder
}

// Minimal GLB → single BufferGeometry loader (all site models are one mesh).
// Returns a cancel function for unmount.
export function loadGLB(url: string, onGeo: (g: THREE.BufferGeometry) => void): () => void {
  let live = true
  new GLTFLoader().load(url, (gltf) => {
    if (!live) return
    let found: THREE.BufferGeometry | null = null
    gltf.scene.traverse((o) => {
      if (!found && o instanceof THREE.Mesh) found = o.geometry as THREE.BufferGeometry
    })
    if (found) onGeo(found)
  })
  return () => {
    live = false
  }
}
